import { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { connect, useDispatch } from 'react-redux'
import {
    SmartlyActionItems,
    layoutActions,
    ModalsType,
    canRelease,
    canRedo,
    Analytics,
    SmartlyActionSubtypes,
    canSendInApprovalPhotographicTask,
    LayoutActivityType,
    canAcceptExecution,
    canAcceptApproval,
    GetMessageParams,
} from '@Techedge/digitalportal-shared'
import Sidebar from '../components/Layout/Sidebar/SideBar'
import MainContent from '../components/Layout/MainContent/MainContent'
import { LuxButton, LuxBadgeLabel, useWindowResize, LuxCustomBreadcrumb } from '@lux/wardrobe-lib'
import Accordion from '../components/Layout/Accordion/Accordion'
import { ActionProps, ActionsProps } from '@models/action'
import Questions from '../components/ActivityExecution/Action/Questions/Questions'
import { QuestionProps } from '@models/question'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '@redux/reducers/activity-execution'
import Action from '../components/ActivityExecution/Action/Action'
import { TaskProps } from '@models/task'
import Tasks from '../components/ActivityExecution/Action/Tasks/Tasks'
import ProjectSpecs from '../components/ActivityExecution/ProjectSpecs/ProjectSpecs'
import MainInformation from '../components/ActivityExecution/MainInformation/MainInformation'
import Messaging from '../components/ActivityExecution/Messaging/Messaging'
import { SurveyProps } from '@models/survey'
import Surveys from '../components/ActivityExecution/Action/Surveys/Surveys'
import ActionApproval from '../components/ActivityApproval/ActionApproval/ActionApproval'
import {
    acceptApprovalPhotographicTask,
    acceptApprovalServiceRequestApprovalDetail,
    acceptPhotographicTask,
    answerQuestion,
    cancelProject,
    getAssignees,
    getMessage,
    getProjectDetails,
    getSurveyStatus,
    markAsRead,
    recallProject,
    reloadProjectStatus,
    saveAsToBeReleased,
    setIsApproval,
    setIsFullScreen,
    setIsMultiStore,
    setMessageList,
    setStoreId,
    taskEmptyAnswer,
} from '@redux/actions/activity-execution'
import ApprovalDetail from '../components/ActivityApproval/ApprovalDetail/ApprovalDetail'
import { NEW_ACTIVITY_APPROVAL_REDUCER_NAMESPACE } from '@redux/reducers/activity-approval'
import { getExecutionProjectSpecsDetail, getSaveAsDraftBody } from '@utils/activityAdapter'
import { ProjectApiCreateActivityBody, ProjectApiStatus } from '@models/projects-service'
import {
    approveStore as approveStore,
    closeProject as closeProjectAction,
    redoStore,
    setApprovalStoreList,
    setSelectedStores,
} from '../redux/actions/activity-approval'
import {
    createProject,
    editProject,
    NewActivityCreationActions,
    rejectProject,
    releaseProject,
    resetAllForm,
    setActivityKey,
} from '@redux/actions/activity-creation'
import {
    approvalCta,
    approvalStoreCta,
    executionCta,
    executionNewsCta,
} from '@models/new-activity-creation-cta'
import { CtaGroupWrapper } from '@components/UI/CtaGroup/CtaGroupWrapper'
import DialogRedo from '../components/UI/Dialogs/DialogRedo/DialogRedo'
import { setQuestionStatus } from '@utils/newActivityQuestionsStatus'
import DialogDuplicate from '../components/UI/Dialogs/DialogDuplicate/DialogDuplicate'
import DialogReject from '../components/UI/Dialogs/DialogReject/DialogReject'
import RedoReasons from '../components/ActivityExecution/RedoReasons/RedoReasons'
import DialogEditConfirm from '../components/UI/Dialogs/DialogEditConfirm/DialogEditConfirm'
import { StoreProps } from '@models/store'
import { statusColors } from '@utils/statusColorMap'
import { getTaskProgress } from '@utils/getTaskProgress'
import { executionAnalyticsPageTypeMap } from '@models/analyticsPageTypeMap'
import EditingReason from '../components/ActivityCreation/EditingReason/EditingReason'
import { getFiltersDomain } from '@redux/actions/filters'
import moment from 'moment'
import ReassignDialog from '../components/ActivityExecution/ReassignDialog/ReassignDialog'
import { DelegateType } from '@models/assignee'
import './TaskCommunicationExecution.scss'
import { getBreadcrumbs } from '@utils/commonFunctions'

const TaskCommunicationExecution = (props: any) => {
    const {
        onClose,
        messageList,
        isApproval,
        setIsApproval,
        selectedStores,
        isMultiStore,
        storeId,
        setStoreId,
        projectId,
        storeIdList,
        approveStore,
        closeProjectAction,
        redoStore,
        isFullScreen,
        setIsFullScreen,
        goToEdit,
        cancelProject,
        releaseProject,
        rejectProject,
        markAsRead,
        user,
        recallProject,
        saveAsToBeReleased,
        taskEmptyAnswerDispatch,
        setSelectedStore,
        setApprovalStoreList,
        editProject,
        reloadProjectStatus,
        getFiltersDomain,
        activityPhotoList,
        acceptPhotographicTask,
        acceptApprovalPhotographicTask,
        executionProjectId,
        isPhotographicApprovalAccept,
        acceptApprovalServiceRequestApprovalDetail,
        isFromVisit,
        setActivityKey,
        onCloseSurveyTask,
        layoutBreadcrumbs,
        setBreadcrumbNavigation,
        resetBreadcrumbs,
        getMessage
    } = props

    const intl = useIntl()
    const dispatch = useDispatch()
    const componentClass = 'smart-modals-activity-execution'

    const [activeDetail, setActiveDetail] = useState<number>(0)
    // 0: GENERALE - 1: SINGLE STORE QUESTIONS - 2: SINGLE STORE TASKS - 3: SINGLE STORE SURVEYS - 4: STORES DETAIL

    const [activeIndexAction, setActiveIndexAction] = useState<0 | null>(null)
    const [activeIndexMessaging, setActiveIndexMessaging] = useState<0 | null>(null)
    const [activeIndexProjectSpecs, setActiveIndexProjectSpecs] = useState<0 | null>(0)
    const [activeIndexRedoReasons, setActiveIndexRedoReasons] = useState<0 | null>(null)
    const [projectDetails, setProjectDetails] = useState<any>(null)
    const [questions, setQuestions] = useState<QuestionProps[]>([])
    const [tasks, setTasks] = useState<TaskProps[]>([])
    const [surveys, setSurveys] = useState<SurveyProps[]>([])

    const [openDialogRedo, setOpenDialogRedo] = useState<boolean>(false)
    const [showDuplicateDialog, setShowDuplicateDialog] = useState(false)

    const [showRejectDialog, setShowRejectDialog] = useState(false)
    const [rejectReasons, setRejectReasons] = useState('')

    const [showEditDialogConfirm, setShowEditDialogConfirm] = useState(false)
    const [showReassignDialog, setShowReassignDialog] = useState(false)
    const [projectType, setProjectType] = useState()
    const [headerHeight, setHeaderHeight] = useState()
    const isMobile = useWindowResize()

    const [taskCreationDate, setTaskCreationDate] = useState([])
    const [selectedStoreToExecute, setSelectedStoreToExecute] = useState(null)

    const [showAcceptDisclaimer, setShowAcceptDisclaimer] = useState(false)
    const [delegateType, setDelegateType] = useState(DelegateType.executor)
    const [pathArray, setPathArray] = useState<any[]>([])
    const [storedLayoutBreadcrumbs, setStoredLayoutBreadcrumbs] = useState<any[]>([]) // used to memorize layoutBreadcrumbs after reset them

    const onDialogConfirm = (confirm) => {
        setShowEditDialogConfirm(false)
        if (confirm) {
            goToEdit({
                id: projectDetails._id,
                storeIdList: projectDetails.storesIdList[0],
                isEdit: true,
                type: projectDetails.type,
            })
        }
    }

    const goToProgress = () => {
        setIsApproval(false)
    }

    const [breadcrumbs, setBreadcrumbs] = useState([])

    const ctaHandler = (action: string, payload: any) => {
        switch (action) {
            case NewActivityCreationActions.SAVE_AS_TO_BE_RELEASED:
                saveAsToBeReleased(
                    projectDetails._id,
                    intl.formatMessage({
                        id: 'modals.activity.create.conclude.success.message',
                        defaultMessage: 'Project created successfully!',
                    }),
                    storeIdList
                )
                break
            case NewActivityCreationActions.SAVE_AS_DRAFT:
                let newProjectDetails = { ...projectDetails }
                newProjectDetails.questions =
                    projectDetails?.storesList?.length > 0 &&
                    projectDetails?.storesList[0]?.questionsStores?.length > 0
                        ? projectDetails?.storesList[0]?.questionsStores[0]?.questionStore || []
                        : []
                newProjectDetails.jobs =
                    projectDetails?.storesList?.length > 0 &&
                    projectDetails?.storesList[0]?.jobsStores?.length > 0
                        ? projectDetails?.storesList[0]?.jobsStores[0]?.jobStore || []
                        : []
                editProject(
                    getSaveAsDraftBody(newProjectDetails),
                    intl.formatMessage({
                        id: 'modals.activity.create.draft.success.message',
                        defaultMessage: 'Project saved as draft successfully!',
                    }),
                    'draft'
                )
                break
            case NewActivityCreationActions.SAVE_AS_IN_PROGRESS:
                goToProgress()
                break
            case NewActivityCreationActions.SAVE_AS_IN_APPROVAL:
                const store = props.projectDetails.storesList.find(
                    (store) => store.storeId === storeId
                )
                const reloadPhoto = canSendInApprovalPhotographicTask(projectDetails.projectType, {
                    ...projectDetails,
                    ...store,
                    executorUserInfo:
                        store.executorUserInfo?.find((e) => e?.userId === user.user_id) || {},
                })
                approveStore({
                    projectId: projectDetails._id,
                    storeId,
                    successMessage: intl.formatMessage({
                        id: 'modals.activity.approval.store.success.message',
                        defaultMessage: 'Store approved successfully!',
                    }),
                    reloadPhotoList: reloadPhoto,
                })
                break
            case NewActivityCreationActions.CLONE:
                setShowDuplicateDialog(true)
                break
            case NewActivityCreationActions.CLOSE_PROJECT:
                closeProjectAction(
                    projectDetails._id,
                    !!payload && payload.storeId
                        ? [payload.storeId]
                        : projectDetails?.storesList.map((s) => s.storeId),
                    intl.formatMessage({
                        id: 'modals.activity.approval.close.project.success.message',
                        defaultMessage: 'Project closed successfully!',
                    }),
                    storeIdList
                )
                break
            case NewActivityCreationActions.CLOSE_ALL:
                closeProjectAction(
                    projectDetails._id,
                    selectedStores.map((store) => store.storeId),
                    intl.formatMessage({
                        id: 'modals.activity.approval.close.project.success.message',
                        defaultMessage: 'Project closed successfully!',
                    }),
                    storeIdList
                )
                break
            case NewActivityCreationActions.REDO:
                redoStore(
                    projectDetails._id,
                    [payload.storeId],
                    payload.question,
                    payload.task,
                    payload.survey,
                    intl.formatMessage({
                        id: 'modals.activity.approval.redo.store.success.message',
                        defaultMessage: 'Store redo successfully!',
                    }),
                    payload.successCallback,
                    storeIdList
                )
                break
            case NewActivityCreationActions.REDO_ALL:
                setOpenDialogRedo(true)
                break
            case NewActivityCreationActions.RECALL_PROJECT:
                recallProject(
                    projectDetails._id,
                    intl.formatMessage({
                        id: 'modals.activity.approval.recall.success.message',
                        defaultMessage: 'Project recalled successfully!',
                    })
                )
                break
            case NewActivityCreationActions.EDIT:
                setShowEditDialogConfirm(true)
                break
            case NewActivityCreationActions.CANCEL:
                cancelProject(
                    projectDetails._id,
                    intl.formatMessage({
                        id: 'modals.activity.approval.cancel.success.message',
                        defaultMessage: 'Store redo successfully!',
                    })
                )
                break
            case NewActivityCreationActions.RELEASE:
                releaseProject(
                    projectDetails._id,
                    intl.formatMessage({
                        id: 'modals.activity.create.release.success.message',
                        defaultMessage: 'Project released successfully!',
                    })
                )
                break
            case NewActivityCreationActions.REJECT:
                setShowRejectDialog(true)
                break
            case NewActivityCreationActions.MARK_AS_READ:
                markAsRead(
                    projectDetails._id,
                    projectDetails.status !== ProjectApiStatus.READ,
                    intl.formatMessage({
                        id: 'modals.activity.mark.as.read.success.message',
                        defaultMessage: 'Confirm reading sent successfully!',
                    }),
                    storeIdList
                )
                break
            case NewActivityCreationActions.ACCEPT_PHOTOGRAPHIC_TASK:
                acceptPhotographicTask({
                    projectId: projectDetails._id,
                    storeId,
                    successMessage: intl.formatMessage({
                        id: 'modals.activity.accept.store.success.message',
                        defaultMessage: 'Store accepted successfully!',
                    }),
                })
                break
            case NewActivityCreationActions.DO_NOT_ACCEPT_PHOTOGRAPHIC_TASK:
            case NewActivityCreationActions.DO_NOT_ACCEPT_APPROVAL_PHOTOGRAPHIC_TASK:
                onBack()
                break
            case NewActivityCreationActions.ACCEPT_APPROVAL_PHOTOGRAPHIC_TASK:
                acceptApprovalPhotographicTask({
                    projectId: projectDetails._id,
                    storeIdList: selectedStores.map((s) => s.storeId),
                    successMessage: intl.formatMessage({
                        id: 'modals.activity.accept.store.success.message',
                        defaultMessage: 'Store accepted successfully!',
                    }),
                    callback: () => {
                        if (storeId) {
                            let url = `/gallery/detail/${projectDetails._id}?selectedStores=${storeId}`
                            window.location.href = window.location.origin + url
                        }
                    },
                })
                break
            case NewActivityCreationActions.ACCEPT_APPROVAL_SERVICE_REQUEST_APPROVAL_DETAIL:
                acceptApprovalServiceRequestApprovalDetail({
                    projectId: projectDetails._id,
                    storeIdList: selectedStores.map((s) => s.storeId),
                    successMessage: intl.formatMessage({
                        id: 'modals.activity.accept.store.success.message',
                        defaultMessage: 'Store accepted successfully!',
                    }),
                })
                break
            case NewActivityCreationActions.REASSIGN:
                setShowReassignDialog(true)
                break
        }
    }

    const onRedoAllConfirm = (question, task, survey) => {
        const redoStores = selectedStores.filter((s) =>
            canRedo(projectDetails.projectType as SmartlyActionItems, {
                status: s.status.key,
                module: 'communication',
                type: 'communication',
            })
        )
        redoStore(
            projectDetails._id,
            redoStores.map((store) => store.storeId),
            question,
            task,
            survey,
            intl.formatMessage({
                id: 'modals.activity.approval.redo.store.success.message',
                defaultMessage: 'Store redo successfully!',
            }),
            () => setOpenDialogRedo(false),
            storeIdList
        )
    }

    const onRejectConfirm = () => {
        setShowRejectDialog(false)
        rejectProject(
            projectDetails._id,
            rejectReasons,
            intl.formatMessage({
                id: 'modals.activity.create.reject.success.message',
                defaultMessage: 'Project rejected successfully!',
            })
        )
    }

    const calculateProgress = (arrayData: any[], id: number) => {
        if (arrayData?.length > 0) {
            switch (id) {
                case 1:
                    let completedQuestions = 0
                    for (let i = 0; i < arrayData.length; i++) {
                        let q = arrayData[i]
                        if (!!q.answer) {
                            if (q.questionType === 'multiChoice') {
                                if (
                                    (q.answer && q.answer.length > 0 && !q.attachmentsRequired) ||
                                    (q.answer &&
                                        q.answer.length > 0 &&
                                        q.attachmentsRequired &&
                                        q.answerAttachments?.length > 0)
                                ) {
                                    completedQuestions++
                                }
                            } else {
                                if (
                                    (!!q.answer && !q.attachmentsRequired) ||
                                    (!!q.answer &&
                                        q.attachmentsRequired &&
                                        q.answerAttachments?.length > 0)
                                ) {
                                    completedQuestions++
                                }
                            }
                        }
                    }
                    return completedQuestions ? (completedQuestions / arrayData.length) * 100 : 0
                case 2:
                    let answers = 0
                    let totalQuestions = 0
                    for (let i = 0; i < arrayData.length; i++) {
                        let t = arrayData[i]
                        let questions = t?.questions
                        if (questions?.length) {
                            // let answers = 0
                            for (let x = 0; x < questions.length; x++) {
                                totalQuestions++
                                let q = questions[x]
                                if (q.questionType === 'multiChoice') {
                                    if (
                                        (q.answer &&
                                            q.answer.length > 0 &&
                                            !q.attachmentsRequired) ||
                                        (q.answer &&
                                            q.answer.length > 0 &&
                                            q.attachmentsRequired &&
                                            q.answerAttachments?.length > 0)
                                    ) {
                                        answers++
                                    }
                                } else {
                                    if (
                                        (!!q.answer && !q.attachmentsRequired) ||
                                        (!!q.answer &&
                                            q.attachmentsRequired &&
                                            q.answerAttachments?.length > 0)
                                    ) {
                                        answers++
                                    }
                                }
                            }
                        }
                    }
                    return answers ? (answers / totalQuestions) * 100 : 0
                case 3:
                    let completedSurveys = 0
                    for (let i = 0; i < arrayData.length; i++) {
                        if (!!arrayData[i]?.answer) {
                            completedSurveys++
                        }
                    }
                    return completedSurveys ? (completedSurveys / arrayData.length) * 100 : 0
                default:
                    return 0
            }
        }
        return 0
    }

    const _cta = () => {
        switch (activeDetail) {
            case 1:
            case 2:
            case 3:
                return (
                    <>
                        <LuxButton
                            variant={'outlined'}
                            onClick={() => {
                                onBack()
                            }}
                            text={intl.formatMessage({
                                id: 'modals.news_execution.button.continue_execution',
                                defaultMessage: 'Continue execution',
                            })}
                        />
                    </>
                )
            case 4:
                const ctaApprovalStore = approvalStoreCta(
                    projectDetails?.projectType as SmartlyActionItems,
                    projectDetails,
                    user
                )
                return (
                    projectDetails &&
                    projectDetails._id &&
                    selectedStores.filter((store) => store.status.key !== 'closed').length > 0 && (
                        <CtaGroupWrapper
                            ctaConfig={ctaApprovalStore}
                            componentClass={componentClass}
                            ctaHandler={ctaHandler}
                        />
                    )
                )
            default:
                let ctaExecApproval
                if (!isApproval && projectDetails?.projectType !== 'news') {
                    let noAnswer
                    let store
                    if (storeId) {
                        store = props.projectDetails.storesList.find(
                            (store) => store.storeId === storeId
                        )
                        noAnswer = !store.answer
                    }
                    let details =
                        projectDetails?.type === SmartlyActionSubtypes.PICTURE_MGMT
                            ? {
                                  ...projectDetails,
                                  ...store,
                                  // se abbiamo lo storeId siamo nella vista di uno store selezionato,
                                  // forziamo la lista in questo modo per il caso della save as approval
                                  // (task photographic), dopo la chiamata viene richiamato getProjectDetails
                                  // senza stores, quindi il controllo delle cta viene falsato.
                                  // Forzatura necessaria per evitare regressioni per il communication.
                                  storesList: store ? [store] : projectDetails.storesList,
                                  assignment: !!store?.executorUserInfo?.length
                                      ? [
                                            ...store?.executorUserInfo
                                                ?.filter((u) => !u.userId)
                                                .map((u) => u.role),
                                            ...store?.executorUserInfo
                                                ?.filter((u) => !!u.userId)
                                                .map((u) => u.role),
                                        ]
                                      : projectDetails?.assignment?.filter(
                                            (a, i) => projectDetails?.assignment?.indexOf(a) === i
                                        ),
                                  approvers: !!store?.approvalUserInfo?.length
                                      ? [
                                            ...store?.approvalUserInfo
                                                ?.filter((u) => !u.userId)
                                                .map((u) => u.role),
                                        ]
                                      : projectDetails.approvers,
                                  delegatedExecutorUserIds: store?.executorUserInfo
                                      ?.filter((u) => !!u.userId)
                                      .map((u) => u.userId),
                                  delegatedApprovalUserIds: store?.approvalUserInfo
                                      ?.filter((u) => !!u.userId)
                                      .map((u) => u.userId),
                              }
                            : { ...projectDetails, status: store?.status || projectDetails?.status }
                    ctaExecApproval = executionCta(
                        projectDetails?.projectType as SmartlyActionItems,
                        details,
                        user,
                        storeId,
                        isPhotographicApprovalAccept
                    ).setDisableConditions([
                        {
                            action: NewActivityCreationActions.SAVE_AS_IN_APPROVAL,
                            disableCondition:
                                isApproval ||
                                (questions?.length > 0 &&
                                    calculateProgress(questions, 1) !== 100) ||
                                (tasks?.length > 0 && calculateProgress(tasks, 2) !== 100) ||
                                (surveys?.length > 0 && calculateProgress(surveys, 3) !== 100) ||
                                (projectDetails?.type !== SmartlyActionSubtypes.PICTURE_MGMT &&
                                    questions?.length == 0 &&
                                    tasks.length == 0 &&
                                    surveys.length == 0 &&
                                    noAnswer) ||
                                (projectDetails?.type === SmartlyActionSubtypes.PICTURE_MGMT &&
                                    activityPhotoList.filter((p) => p.status !== 'rejected')
                                        .length < projectDetails.numberOfPhotos),
                        },
                        {
                            action: NewActivityCreationActions.SAVE_AS_IN_PROGRESS,
                            disableCondition: !isApproval,
                        },
                    ])
                }
                if (!isApproval && projectDetails?.projectType === 'news')
                    ctaExecApproval = executionNewsCta(
                        projectDetails?.projectType as SmartlyActionItems,
                        projectDetails
                    )
                if (isApproval && projectDetails?.status !== 'rejected')
                    ctaExecApproval = approvalCta(
                        projectDetails?.projectType as SmartlyActionItems,
                        projectDetails,
                        user
                    ).setDisableConditions([
                        {
                            action: NewActivityCreationActions.ACCEPT_APPROVAL_PHOTOGRAPHIC_TASK,
                            disableCondition: !selectedStores.length,
                        },
                        {
                            action: NewActivityCreationActions.DO_NOT_ACCEPT_APPROVAL_PHOTOGRAPHIC_TASK,
                            disableCondition: !selectedStores.length,
                        },
                    ])
                if (isApproval && projectDetails?.status === 'rejected')
                    ctaExecApproval = executionCta(
                        projectDetails?.projectType as SmartlyActionItems,
                        projectDetails,
                        user,
                        storeId
                    )
                return (
                    projectDetails &&
                    projectDetails._id && (
                        <CtaGroupWrapper
                            ctaConfig={ctaExecApproval}
                            componentClass={componentClass}
                            ctaHandler={ctaHandler}
                        />
                    )
                )
        }
    }
    // PERMISSION CTA
    const footer = (
        <div className={`${componentClass}__footer wrapper`} data-count={activeDetail > 0 ? 1 : 2}>
            {_cta()}
        </div>
    )

    const [taskEmptyAnswer, setTaskEmptyAnswer] = useState<string>('')
    const [taskEmptyAnswerAttachments, setTaskEmptyAnswerAttachments] = useState<{
        attachmentList: { value: any[] }
    }>({ attachmentList: { value: [] } })
    const [actions, setActions] = useState<ActionsProps>({
        questions: {
            id: 1,
            title: intl.formatMessage({
                id: 'modals.news_execution.action.action_card.title.questions',
                defaultMessage: 'Questions',
            }),
            count: questions.length,
            progress: calculateProgress(questions, 1),
            onClick: () => setActiveDetail(1),
        },
        tasks: {
            id: 2,
            title: intl.formatMessage({
                id: 'modals.news_execution.action.action_card.title.tasks',
                defaultMessage: 'Tasks',
            }),
            count: tasks.length,
            progress: calculateProgress(tasks, 2),
            onClick: () => setActiveDetail(2),
        },
        surveys: {
            id: 3,
            title: intl.formatMessage({
                id: 'modals.news_execution.action.action_card.title.surveys',
                defaultMessage: 'Surveys',
            }),
            count: surveys.length,
            progress: calculateProgress(surveys, 3),
            onClick: () => setActiveDetail(3),
        },
    })

    const [sidebarInfo, setSidebarInfo] = useState({
        title: intl.formatMessage({
            id: 'modals.news_execution.project_specs.title',
            defaultMessage: 'Project Specs',
        }),
        status: null,
        subtitle: null,
        details: [],
        stores: [],
    })

    // const [delegationNames, setDelegationNames] = useState<{ value: string; label: string }[]>([])

    // FUNCTIONS

    const onBack = () => {
        if (storeId) {
            if (activeDetail > 0) {
                setActiveDetail(0)
                setSidebarInfo({
                    ...sidebarInfo,
                    title: intl.formatMessage({
                        id: 'modals.news_execution.project_specs.title',
                        defaultMessage: 'Project Specs',
                    }),
                    details: getExecutionProjectSpecsDetail(projectDetails, intl).map((detail) => ({
                        ...detail,
                        label: intl.formatMessage({ id: detail.label }),
                    })),
                })
            } else {
                if (isMultiStore) {
                    setStoreId(null)
                    props.getProjectDetails(
                        projectId,
                        !!storeIdList && storeIdList.length === 1 ? storeIdList : null
                    )
                    setSidebarInfo({
                        ...sidebarInfo,
                        stores: [],
                    })
                    setTaskEmptyAnswer('')
                    setEmptyAnswerAssignment([])
                    setEmptyAnswerStatus('')
                } else {
                    onClose()
                }
            }
        } else if (activeDetail === 4) {
            setActiveDetail(0)
            setStoreId(null)
            setSidebarInfo({
                ...sidebarInfo,
                stores: [],
            })
            setSelectedStore([])
        } else {
            if (projectDetails.type === LayoutActivityType.SURVEY_TASK && isFromVisit) {
                onCloseSurveyTask({
                    type: ModalsType.VISIT_EXECUTION,
                    props: {
                        id: projectDetails.parentId,
                        storeIds: projectDetails.storesIdList,
                        survey_id: null,
                        loading: false,
                        isEdit: false,
                        isClone: false,
                        storeIdList: null,
                        isFromVisit: false,
                    },
                })
                return
            }
            onClose()
        }
        ;(
            document.getElementsByClassName('smart-modals-main-content__body')[0] as HTMLElement
        ).scrollTop = 0
    }

    const handlerAnswerQuestion = (
        projectId: string,
        questionId: string,
        answer: string,
        jobId?: string,
        answerAttachments?: any[]
    ) => {
        props.answerQuestion(
            projectId,
            questionId,
            answer,
            jobId,
            intl.formatMessage({
                id: 'modals.activity.execution.question.answer.success.message',
                defaultMessage: 'Question answered successfully!',
            }),
            answerAttachments
        )
    }

    const getDetailSection = () => {
        switch (activeDetail) {
            case 1:
                return (
                    <Questions
                        questions={questions}
                        setQuestions={setQuestions}
                        answerQuestion={handlerAnswerQuestion}
                    />
                )
            case 2:
                return (
                    <Tasks
                        tasks={tasks}
                        setTasks={setTasks}
                        answerQuestion={handlerAnswerQuestion}
                        setTaskCreationDate={setTaskCreationDate}
                        taskCreationDate={taskCreationDate}
                    />
                )
            case 3:
                return (
                    <Surveys
                        surveys={surveys}
                        setSurveys={setSurveys}
                        surveyUrlQueryString={`?user_id=${user.user_id}&project_id=${projectDetails._id}&store_id=${storeId}`}
                        onCloseDialog={() => reloadProjectStatus(projectId, [storeId])}
                        projectsDetails={projectDetails}
                        loadingSurveyStatus={props.loadingSurveyStatus}
                        surveyStatusUpdateMap={props.surveyStatusUpdateMap}
                        getSurveyStatus={props.getSurveyStatus}
                    />
                )
            case 4:
                return (
                    <ApprovalDetail
                        stores={selectedStores}
                        onBack={onBack}
                        onRedo={(storeId, question, task, survey, successCallback) =>
                            ctaHandler(NewActivityCreationActions.REDO, {
                                storeId,
                                question,
                                task,
                                survey,
                                successCallback,
                            })
                        }
                        onClose={(storeId) => {
                            ctaHandler(NewActivityCreationActions.CLOSE_PROJECT, {
                                storeId,
                            })
                        }}
                        hasStatusList={
                            projectDetails.projectType === 'news' ||
                            projectDetails.requiredConfirmReading
                        }
                        showReassignApproval={reassignApproverEnabled()}
                    />
                )
        }
    }

    const [emptyAnswerAssignment, setEmptyAnswerAssignment] = useState([])
    const [emptyAnswerStatus, setEmptyAnswerStatus] = useState('')

    const onSelectedStore = (storeId: string) => {
        setSelectedStoreToExecute(projectDetails?.storesList.find((s) => s.storeId === storeId))
        reloadProjectStatus(projectId, [storeId], (data) => {
            let store = data?.storesList?.find((s) => s.storeId === storeId)
            setStoreId(storeId)
            setTaskEmptyAnswer(store?.answer || '')
            setEmptyAnswerAssignment(data?.assignment || [])
            setEmptyAnswerStatus(store?.status || '')
        })
    }

    const updateBreadcrumbs = () => {
        let breadcrumbActivity = document.querySelector(
            '.smart-modals-header__breadcrumb nav ul li.activity'
        )
        let breadcrumbProjectExecution = document.querySelector(
            '.smart-modals-header__breadcrumb nav ul li.project_execution'
        )
        let breadcrumbActivitySummary = document.querySelector(
            '.smart-modals-header__breadcrumb nav ul li.breadcrumb_activity'
        )
        let breadcrumbStoreId = document?.querySelector(
            '.smart-modals-header__breadcrumb nav ul li.store_id'
        )
        const breadcrumbActivitySummaryHandler = () => {
            setStoreId(null)
            setActiveDetail(0)

            setSidebarInfo({
                ...sidebarInfo,
                title: intl.formatMessage({
                    id: 'modals.news_execution.project_specs.title',
                    defaultMessage: 'Project Specs',
                }),
                details: getExecutionProjectSpecsDetail(props.projectDetails, intl).map(
                    (detail) => ({
                        ...detail,
                        label: intl.formatMessage({ id: detail.label }),
                    })
                ),
                stores: [],
            })
            props.getProjectDetails(
                projectId,
                !!storeIdList && storeIdList.length === 1 ? storeIdList : null
            )
        }
        const breadcrumbProjectExecutionClick = () => {
            setStoreId(null)
            setActiveDetail(0)

            setSidebarInfo({
                ...sidebarInfo,
                title: intl.formatMessage({
                    id: 'modals.news_execution.project_specs.title',
                    defaultMessage: 'Project Specs',
                }),
                details: getExecutionProjectSpecsDetail(props.projectDetails, intl).map(
                    (detail) => ({
                        ...detail,
                        label: intl.formatMessage({ id: detail.label }),
                    })
                ),
                stores: [],
            })
        }
        let breadcrumbStoreIdClick = () => {
            setActiveDetail(0)
            setSidebarInfo({
                ...sidebarInfo,
                stores: [{ storeId: storeId, storeName: storeId }],
            })
        }
        if (breadcrumbActivity)
            breadcrumbActivity.addEventListener('click', () => {
                onClose()
            })
        if (breadcrumbProjectExecution)
            breadcrumbProjectExecution.addEventListener('click', breadcrumbProjectExecutionClick)
        if (breadcrumbActivitySummary)
            breadcrumbActivitySummary.addEventListener('click', breadcrumbActivitySummaryHandler)
        if (breadcrumbStoreId) breadcrumbStoreId?.addEventListener('click', breadcrumbStoreIdClick)
        return () => {
            if (breadcrumbActivity)
                breadcrumbActivity.removeEventListener('click', () => {
                    onClose()
                })
            if (breadcrumbProjectExecution)
                breadcrumbProjectExecution.removeEventListener(
                    'click',
                    breadcrumbProjectExecutionClick
                )
            if (breadcrumbActivitySummary)
                breadcrumbActivitySummary.removeEventListener(
                    'click',
                    breadcrumbActivitySummaryHandler
                )
            if (breadcrumbStoreId)
                breadcrumbStoreId?.removeEventListener('click', breadcrumbStoreIdClick)
        }
    }

    const getCanUpload = () => {
        const executorUserInfo =
            (
                projectDetails?.storesList?.find((store) => store.storeId === storeId)
                    ?.executorUserInfo || []
            ).find((e) => e?.userId === user.user_id && e.isAccepted) || {}
        return (
            !!projectDetails?._id &&
            canSendInApprovalPhotographicTask(projectDetails?.projectType as SmartlyActionItems, {
                ...projectDetails,
                ...projectDetails?.storesList?.find((store) => store.storeId === storeId),
                executorUserInfo,
                assignment: [executorUserInfo.role],
            })
        )
    }

    const reassignApproverEnabled = () => {
        return (
            projectDetails?.creatorUserInfo.userId === user.user_id &&
            canAcceptApproval(projectDetails?.projectType as SmartlyActionItems, projectDetails)
        )
    }

    const onReassignApprover = () => {
        setDelegateType(DelegateType.approver)
        setShowReassignDialog(true)
    }

    // USE EFFECTS

    useEffect(() => {
        if (!!projectType) {
            if (
                !isApproval &&
                projectDetails?.status !== 'draft' &&
                projectDetails?.status !== 'toBeReleased'
            ) {
                // execution
                Analytics._sendAnalyticsLinkEvent(
                    'Activities',
                    executionAnalyticsPageTypeMap[projectDetails.projectType][projectDetails.module]
                        .execution,
                    'Static'
                )
            }
            if (
                canRelease(projectDetails.projectType, projectDetails) &&
                projectDetails?.status === 'toBeReleased'
            ) {
                // release
                Analytics._sendAnalyticsLinkEvent(
                    'Activities',
                    executionAnalyticsPageTypeMap[projectDetails.projectType][projectDetails.module]
                        ?.release,
                    'Static'
                )
            }
            if (
                isApproval &&
                projectDetails?.status !== 'draft' &&
                projectDetails?.status !== 'toBeReleased'
            ) {
                // approval
                Analytics._sendAnalyticsLinkEvent(
                    'Activities',
                    executionAnalyticsPageTypeMap[projectDetails.projectType][projectDetails.module]
                        .approval,
                    'Static'
                )
            }
        }
    }, [projectType])

    const setCustomBreadcrumbs = () => {
        const customBreadcrumbs = getBreadcrumbs()
        let storedBreadcrumbs = storedLayoutBreadcrumbs
        if (layoutBreadcrumbs && layoutBreadcrumbs.length > 0) {
            storedBreadcrumbs = layoutBreadcrumbs
            setStoredLayoutBreadcrumbs(storedBreadcrumbs)
            resetBreadcrumbs()
        }
        if (storedBreadcrumbs && storedBreadcrumbs.length > 0) {
            setPathArray(storedBreadcrumbs)
        } else {
            if (customBreadcrumbs && customBreadcrumbs.length > 0) {
                customBreadcrumbs.forEach((item, index) => {
                    item.id = index
                    item.label = intl.formatMessage({
                        id: `modals.new.activity.breadcrumbs.${item.name}`,
                        defaultMessage: item.name,
                    })
                    item.className = 'activity selectable force-opacity-1'
                    item.disabled = false
                })
                breadcrumbs
                    .filter((item) => item.isVisible)
                    .forEach((item, index) => {
                        customBreadcrumbs.push({ ...item, id: breadcrumbs.length + index })
                    })
                setPathArray(customBreadcrumbs)
            }
        }
    }

    useEffect(() => {
        getFiltersDomain()
        return () => {
            setQuestions([])
            setTasks([])
            setSurveys([])
            setHasNoAction(false)
            setProjectDetails(null)
        }
    }, [])

    useEffect(() => {
        setCustomBreadcrumbs()
    }, [breadcrumbs])

    useEffect(() => {
        if (props.projectDetails) {
            setActivityKey(props.projectDetails.projectType)
            setProjectDetails(props.projectDetails)
            setProjectType(props.projectDetails.projectType)
            setSidebarInfo({
                ...sidebarInfo,
            })
            if (storeId) {
                let store = props.projectDetails.storesList.find(
                    (store) => store.storeId === storeId
                )
                setTaskEmptyAnswer(store.answer || '')
                setEmptyAnswerStatus(store.status || '')
            }

            if (activeDetail !== 4) {
                setSidebarInfo({
                    ...sidebarInfo,
                    title: intl.formatMessage({
                        id: 'modals.news_execution.project_specs.title',
                        defaultMessage: 'Project Specs',
                    }),
                    subtitle: props.projectDetails.projectTitle,
                    details: getExecutionProjectSpecsDetail(props.projectDetails, intl).map(
                        (detail) => ({
                            ...detail,
                            label: intl.formatMessage({ id: detail.label }),
                        })
                    ),
                })
            }
        }
    }, [props.projectDetails])

    const [hasNoAction, setHasNoAction] = useState(false)

    useEffect(() => {
        if (!!projectDetails && projectDetails.enableMessaging) {
            getMessage({
                projectId: projectDetails._id,
                isDetail: true,
                isLoadMore: false,
                pageNum: 1,
            })
        }
    }, [projectDetails])

    useEffect(() => {
        if (projectDetails) {
            if (!!projectDetails._id) {
                if (projectDetails?.storesList?.length > 0) {
                    setApprovalStoreList([...projectDetails?.storesList])
                    const newSelectedStore = [
                        ...selectedStores.map((store: StoreProps) => {
                            const newStore = projectDetails?.storesList.find(
                                (s) => s.storeId === store.storeId
                            )
                            return {
                                ...store,
                                status: {
                                    label: newStore?.status
                                        ? intl.formatMessage({
                                              id: `smart.project.status.${newStore?.status}`,
                                              defaultMessage: newStore?.status,
                                          })
                                        : '',
                                    color: statusColors[newStore?.status],
                                    key: newStore?.status,
                                },
                            }
                        }),
                    ]
                    setSelectedStore(newSelectedStore)
                    let store = projectDetails.storesList.find((store) => store.storeId === storeId)
                    // set questions
                    if (store?.questionsStores?.length === 1) {
                        let questionStore = store.questionsStores[0]?.questionStore
                        if (questionStore && questionStore?.length > 0) {
                            let tmpQuestions = []
                            let hasAccepted = store.executorUserInfo?.find(
                                (u) => u.userId === user.user_id
                            )
                            if (projectDetails.type === SmartlyActionSubtypes.SERVICE_REQUEST) {
                                hasAccepted = store.executorUserInfo?.find(
                                    (u) => u.userId === user.user_id && u.isAccepted
                                )
                            }
                            for (let i = 0; i < questionStore.length; i++) {
                                let q: QuestionProps = questionStore[i]
                                let newQuestion = {
                                    ...q,
                                    id: i,
                                    question: `${intl.formatMessage({
                                        id: 'modals.news_execution.action.questions.question',
                                        defaultMessage: 'Question',
                                    })} ${i + 1}`,
                                    questionTitle: q.questionTitle,
                                    questionType: q.questionType,
                                    storeId: q.storeId,
                                    possibleAnswers: q.possibleAnswers,
                                    attachments: !!q.attachments
                                        ? q.attachments.map((attachment) => ({
                                              ...attachment,
                                              hideEyeIcon: true,
                                          }))
                                        : [],
                                    answerAttachments: q.answerAttachments
                                        ? q.answerAttachments.map((attachment) => ({
                                              _id: attachment._id,
                                              file: attachment,
                                              url: !!attachment && attachment.url,
                                              hideEyeIcon: true,
                                          }))
                                        : [],
                                    attachmentsRequired: q.attachmentsRequired,
                                    answer: (q as any).answer,
                                    answers: [],
                                    status: '',
                                    storeStatus: store.status,
                                    assignment: q?.assignment,
                                    assignmentUserId: q.assignmentUserId,
                                    hasAccepted,
                                }
                                tmpQuestions.push(
                                    newQuestion.answer
                                        ? setQuestionStatus(newQuestion)
                                        : newQuestion
                                )
                            }
                            setQuestions(tmpQuestions)
                        }
                    }
                    // set tasks/jobs
                    if (store?.jobsStores?.length === 1) {
                        let jobStore = store.jobsStores[0]?.jobStore
                        if (jobStore && jobStore?.length > 0) {
                            let tmpTasks = []
                            for (let i = 0; i < jobStore.length; i++) {
                                let t: TaskProps = jobStore[i]
                                tmpTasks.push({
                                    ...t,
                                    id: t._id,
                                    title: t.title,
                                    details: t.details,
                                    creation_date: moment(t.startDate).format('L'),
                                    end_date: moment(t.endDate).format('L'),
                                    priority: t.priority,
                                    role: t.assignment.reduce((acc, curr) => {
                                        return (
                                            acc +
                                            ' ' +
                                            intl.formatMessage({
                                                id: `modals.filters.recipient.${curr}`,
                                                defaultMessage: curr,
                                            })
                                        )
                                    }, ''),
                                    questions:
                                        t.questions?.length > 0
                                            ? t.questions.map((q: QuestionProps, i2: number) => {
                                                  let newQuestion = {
                                                      ...q,
                                                      id: q._id,
                                                      question: `${intl.formatMessage({
                                                          id: 'modals.news_execution.action.questions.question',
                                                          defaultMessage: 'Question',
                                                      })} ${i2 + 1}`,
                                                      attachments: !!q.attachments
                                                          ? q.attachments.map((attachment) => ({
                                                                ...attachment,
                                                            }))
                                                          : [],
                                                      answerAttachments: q.answerAttachments
                                                          ? q.answerAttachments.map(
                                                                (attachment) => ({
                                                                    _id: attachment._id,
                                                                    file: attachment,
                                                                    url:
                                                                        !!attachment &&
                                                                        attachment.url,
                                                                })
                                                            )
                                                          : [],
                                                      answer: (q as any).answer,
                                                      answers: [],
                                                      storeStatus: store.status,
                                                      assignment: t.assignment,
                                                      assignmentUserId: t.assignmentUserId,
                                                      hasAccepted:
                                                          store.executorUserInfo?.find(
                                                              (u) => u.userId === user.user_id
                                                          ) ||
                                                          projectDetails?.type !==
                                                              SmartlyActionSubtypes.SERVICE_REQUEST,
                                                  }

                                                  return newQuestion.answer
                                                      ? setQuestionStatus(newQuestion)
                                                      : newQuestion
                                              })
                                            : [],
                                    attachments: !!t.attachments
                                        ? t.attachments.map((attachment) => ({
                                              ...attachment,
                                              hideEyeIcon: true,
                                          }))
                                        : [],
                                    projectId: t.projectId,
                                    status: '',
                                })
                            }
                            setTasks(getTaskProgress(tmpTasks, setQuestionStatus))
                        }
                    }
                    // set surveys
                    if (store?.surveysStores?.length === 1) {
                        let surveysStore = store.surveysStores[0]?.surveysStore
                        if (surveysStore && surveysStore?.length > 0) {
                            let tmpSurveys = []
                            for (let i = 0; i < surveysStore.length; i++) {
                                let s: SurveyProps = surveysStore[i]
                                tmpSurveys.push({
                                    ...s,
                                    id: s.surveyId,
                                    title: `${intl.formatMessage({
                                        id: 'modals.news_execution.action.surveys.survey',
                                        defaultMessage: 'Survey',
                                    })} ${i + 1}`,
                                    description: s.details,
                                    creation_date: moment(s.startDate).format('L'),
                                    end_date: moment(s.endDate).format('L'),
                                    priority: s.priority,
                                    role: intl.formatMessage({
                                        id: `modals.filters.recipient.${s.assignment}`,
                                        defaultMessage: s.assignment,
                                    }),
                                    survey_title: s.title,
                                    survey_url: s.surveyUrl,
                                    attachments: !!s.attachments
                                        ? s.attachments.map((attachment) => ({
                                              ...attachment,
                                              hideEyeIcon: true,
                                          }))
                                        : [],
                                    completed: !!s.answer,
                                    status: !!s.answer ? 'completed' : '',
                                    storeStatus: store.status,
                                    hasAccepted:
                                        store.executorUserInfo?.find(
                                            (u) => u.userId === user.user_id
                                        ) ||
                                        projectDetails?.type !==
                                            SmartlyActionSubtypes.SERVICE_REQUEST,
                                })
                            }
                            setSurveys(tmpSurveys)
                        }
                    }
                    setHasNoAction(
                        !!store?.questionsStores &&
                            !store?.questionsStores[0]?.questionStore.length &&
                            !!store?.jobsStores &&
                            !store?.jobsStores[0]?.jobStore.length &&
                            !store?.surveysStores
                    )
                }

                // check if the user can accept the execution

                if (
                    canRelease(projectDetails.projectType, projectDetails) ||
                    projectDetails.status === 'draft'
                ) {
                    setBreadcrumbs([
                        {
                            id: 2,
                            label: intl.formatMessage({
                                id:
                                    projectDetails.status === 'draft'
                                        ? 'modals.new.activity.breadcrumbs.activity.draft'
                                        : 'modals.new.activity.breadcrumbs.activity.release',
                                defaultMessage:
                                    projectDetails.status === 'draft'
                                        ? 'Project Creation'
                                        : 'Project Release',
                            }),
                            isVisible: true,
                            className: 'project_execution selectable',
                            isProjectBreadcrumb: true,
                        },
                        {
                            id: 3,
                            label: intl.formatMessage({
                                id: 'modals.news_execution.project_specs.stores.selected_stores',
                                defaultMessage: 'Selected stores preview',
                            }),
                            isVisible: activeDetail === 4 || (storeId && activeDetail === 0),
                        },
                    ])
                } else {
                    const breadcrumbsToSet = [
                        {
                            id: 2,
                            label: intl.formatMessage({
                                id: 'modals.news_execution.breadcrumbs.project_execution',
                                defaultMessage: 'Project execution',
                            }),
                            isVisible: true,
                            className: `project_execution ${
                                isApproval ? (storeId || activeDetail > 0 ? '' : '') : ''
                            }`,
                            isProjectBreadcrumb: true,
                        },
                        {
                            id: 3,
                            label: intl.formatMessage({
                                id: 'modals.news_execution.project_specs.stores.selected_stores',
                                defaultMessage: 'Selected stores preview',
                            }),
                            isVisible: activeDetail === 4 || (storeId && activeDetail === 0),
                        },
                        {
                            id: 3,
                            label: intl.formatMessage({
                                id: 'modals.news_execution.action.action_card.title.questions',
                                defaultMessage: 'Questions',
                            }),
                            disabled: true,
                            isVisible: activeDetail === 1,
                        },
                        {
                            id: 3,
                            label: intl.formatMessage({
                                id: 'modals.news_execution.action.action_card.title.tasks',
                                defaultMessage: 'Tasks',
                            }),
                            disabled: true,
                            isVisible: activeDetail === 2,
                        },
                        {
                            id: 3,
                            label: intl.formatMessage({
                                id: 'modals.news_execution.action.action_card.title.surveys',
                                defaultMessage: 'Surveys',
                            }),
                            disabled: true,
                            isVisible: activeDetail === 3,
                        },
                    ]

                    setBreadcrumbs(breadcrumbsToSet)
                }
            }
        }
        // check if the user can accept the execution

        if (
            projectDetails &&
            !projectDetails?.executorUserInfo?.filter(
                (u) => u.userId === user.user_id && u.isAccepted
            ).length
        ) {
            let _canAcceptExecution = false
            if (
                canAcceptExecution(SmartlyActionItems.TASK, projectDetails) ||
                projectDetails?.delegatedExecutorUserIds?.indexOf(user.user_id) > -1
            )
                _canAcceptExecution = true
            else
                projectDetails?.storesList?.forEach((s) => {
                    if (
                        canAcceptExecution(SmartlyActionItems.TASK, {
                            ...projectDetails,
                            status: s.status,
                        })
                    )
                        _canAcceptExecution = true
                })
            setShowAcceptDisclaimer(_canAcceptExecution)
        }
    }, [projectDetails, storeId])

    useEffect(() => {
        if (breadcrumbs.length > 0) updateBreadcrumbs()
        if (activeDetail === 0) {
            if (!storeId)
                props.getProjectDetails(
                    projectId,
                    !!storeIdList && storeIdList.length === 1 ? storeIdList : null
                )
        } else if ([1, 2, 3].includes(activeDetail)) {
            let tmpAction: ActionProps = { ...actions.questions }
            if (activeDetail === 2) {
                tmpAction = { ...actions.tasks }
            } else if (activeDetail === 3) {
                tmpAction = { ...actions.surveys }
            }
            let tmpActionStatus = tmpAction.progress < 100 ? 'not_completed' : 'completed'

            setSidebarInfo({
                ...sidebarInfo,
                title: tmpAction.title,
                details: [
                    {
                        value: tmpAction.count,
                        label: `${intl.formatMessage({
                            id: 'modals.news_execution.project_specs.details.number_of',
                            defaultMessage: 'Number of',
                        })} ${tmpAction.title}`,
                    },
                    {
                        value: intl.formatMessage({
                            id: `modals.news_execution.action.action_card.status.${tmpActionStatus}`,
                            defaultMessage: tmpActionStatus,
                        }),
                        label: intl.formatMessage({
                            id: 'modals.news_execution.action.action_card.status',
                            defaultMessage: 'Status',
                        }),
                    },
                ],
            })
        } else if (activeDetail === 4) {
            setSidebarInfo({
                ...sidebarInfo,
                stores: selectedStores,
            })
        }
    }, [activeDetail, storeId])

    useEffect(() => {
        let tmpTasks = [...tasks]
        let tmpQuestions = [...questions]
        let tmpSurveys = [...surveys]
        setActions({
            questions: {
                ...actions.questions,
                count: tmpQuestions.length,
                progress: calculateProgress(tmpQuestions, 1),
            },
            tasks: {
                ...actions.tasks,
                count: tmpTasks.length,
                progress: calculateProgress(tmpTasks, 2),
            },
            surveys: {
                ...actions.surveys,
                count: tmpSurveys.length,
                progress: calculateProgress(tmpSurveys, 3),
            },
        })
    }, [questions, tasks, surveys])

    useEffect(() => {
        if (storeId) {
            props.getAssignees(storeId)
        }
        if (!executionProjectId) {
            setSidebarInfo({
                ...sidebarInfo,
                stores: storeId ? [{ storeId: storeId, storeName: storeId }] : [],
            })
            return
        }
        setSidebarInfo({
            ...sidebarInfo,
            title: intl.formatMessage({
                id: 'modals.news_execution.project_specs.title',
                defaultMessage: 'Project Specs',
            }),
            subtitle: props.projectDetails.projectTitle,
            details: getExecutionProjectSpecsDetail(props.projectDetails, intl).map((detail) => ({
                ...detail,
                label: intl.formatMessage({ id: detail.label }),
            })),
            stores: storeId ? [{ storeId: storeId, storeName: storeId }] : [],
        })
    }, [storeId])

    useEffect(() => {
        let tmpDelegationNames = []
        if (props?.assignees?.length > 0) {
            let assignees = props.assignees

            for (let i = 0; i < assignees.length; i++) {
                let a = assignees[i]
                tmpDelegationNames.push({
                    value: a?.userId,
                    label: `${a.nickname ? a.nickname : a.firstname}${
                        a.nickname ? '' : ' ' + a.lastname
                    }`,
                })
            }
        }
        // setDelegationNames(tmpDelegationNames)
    }, [props.assignees])

    const onClickBreadcrumb = (breadcrumb: any) => {
        if (breadcrumb.isProjectBreadcrumb) {
            setStoreId(null)
            setActiveDetail(0)
            setSidebarInfo({
                ...sidebarInfo,
                title: intl.formatMessage({
                    id: 'modals.news_execution.project_specs.title',
                    defaultMessage: 'Project Specs',
                }),
                details: getExecutionProjectSpecsDetail(projectDetails, intl).map((detail) => ({
                    ...detail,
                    label: intl.formatMessage({ id: detail.label }),
                })),
                stores: [],
            })
        } else {
            onClose()
        }
        setBreadcrumbNavigation(breadcrumb)
    }

    return (
        <div className="smart-modals-fullscreen">
            <div className={componentClass} data-isfullscreen={isFullScreen}>
                <div className={`${componentClass}__main`}>
                    {!isFullScreen && (
                        <div className={`${componentClass}__sidebar`}>
                            <Sidebar>
                                <div className={`${componentClass}__breadcrumb`}>
                                    <LuxCustomBreadcrumb
                                        pathArray={pathArray}
                                        transparentBg
                                        onClickBreadcrumb={onClickBreadcrumb}
                                    />
                                </div>

                                <h1 className={`${componentClass}__header-mobile`}>
                                    {sidebarInfo.subtitle}
                                    {projectDetails?.status && (
                                        <LuxBadgeLabel
                                            label={intl.formatMessage({
                                                id: `smart.project.status.${projectDetails?.status}`,
                                                defaultMessage: projectDetails?.status,
                                            })}
                                            color={statusColors[projectDetails?.status]}
                                        />
                                    )}
                                </h1>
                                <ProjectSpecs
                                    title={sidebarInfo.title}
                                    status={projectDetails?.status}
                                    subtitle={sidebarInfo.subtitle}
                                    details={sidebarInfo.details}
                                    stores={sidebarInfo.stores}
                                    projectId={projectDetails?._id}
                                />
                            </Sidebar>
                        </div>
                    )}
                    <div
                        className={`${componentClass}__content ${
                            isFullScreen ? 'full-screen' : ''
                        }`}>
                        <MainContent hideFooter={true} headerHeight={headerHeight}>
                            {isMobile && (
                                <div className={`${componentClass}__breadcrumb`}>
                                    <LuxCustomBreadcrumb
                                        pathArray={pathArray}
                                        transparentBg
                                        onClickBreadcrumb={onClickBreadcrumb}
                                    />
                                </div>
                            )}
                            {activeDetail === 0 ? (
                                <>
                                    {(projectDetails?.rejectionUserInfo ||
                                        (!!storeId && !!selectedStoreToExecute?.redoUserInfo)) && (
                                        <Accordion
                                            id={4}
                                            title={intl.formatMessage({
                                                id: projectDetails?.rejectionUserInfo
                                                    ? 'modals.news_execution.accordion.title.rejection_reasons'
                                                    : 'modals.dialog.redo_dialog.title',
                                                defaultMessage: projectDetails?.rejectionUserInfo
                                                    ? 'Rejection Reasons'
                                                    : 'Redo Reasons',
                                            })}
                                            extraIcon={'info'}
                                            activeIndex={activeIndexRedoReasons}
                                            setActiveIndex={setActiveIndexRedoReasons}
                                            className={`${componentClass}__accordion ${componentClass}__redo_reasons`}>
                                            <RedoReasons
                                                actionUserInfo={
                                                    projectDetails.rejectionUserInfo ||
                                                    selectedStoreToExecute?.redoUserInfo
                                                }
                                            />
                                        </Accordion>
                                    )}
                                    {(projectDetails?.reasonChoice ||
                                        projectDetails?.reasonChange ||
                                        projectDetails?.messageStores) && (
                                        <Accordion
                                            id={5}
                                            title={intl.formatMessage({
                                                id: 'modals.new.activity.task.section.editing.reason',
                                                defaultMessage: 'Editing Reason',
                                            })}
                                            extraIcon={'info'}
                                            activeIndex={activeIndexRedoReasons}
                                            setActiveIndex={setActiveIndexRedoReasons}
                                            className={`${componentClass}__accordion ${componentClass}__editing_reasons`}>
                                            <EditingReason
                                                projectType={projectDetails?.projectType}
                                                reasonWhy={
                                                    projectDetails?.reasonChoice &&
                                                    Array.isArray(projectDetails?.reasonChoice)
                                                        ? projectDetails?.reasonChoice
                                                        : [projectDetails?.reasonChoice]
                                                }
                                                editingReason={projectDetails?.reasonChange}
                                                messageForStores={projectDetails?.messageStores}
                                                disabled={true}
                                                onReasonWhy={() => null}
                                                onEditingReason={() => null}
                                                onMessage={() => null}
                                            />
                                        </Accordion>
                                    )}
                                    <Accordion
                                        id={0}
                                        title={intl.formatMessage({
                                            id: 'modals.news_execution.project_specs.title',
                                            defaultMessage: 'Project Specs',
                                        })}
                                        activeIndex={activeIndexProjectSpecs}
                                        setActiveIndex={setActiveIndexProjectSpecs}
                                        className={`${componentClass}__accordion ${componentClass}__project-specs-mobile`}>
                                        <ProjectSpecs
                                            title={sidebarInfo.title}
                                            status={projectDetails?.status}
                                            subtitle={sidebarInfo.subtitle}
                                            details={sidebarInfo.details}
                                            stores={sidebarInfo.stores}
                                            projectId={projectDetails?._id}
                                        />
                                    </Accordion>
                                    <Accordion
                                        id={1}
                                        title={intl.formatMessage({
                                            id: 'modals.news_execution.main_information.title',
                                            defaultMessage: 'Main Information',
                                        })}
                                        activeIndex={0}
                                        className={`${componentClass}__accordion`}>
                                        <MainInformation
                                            title={intl.formatMessage({
                                                id: 'modals.news_execution.main_information.activity_info',
                                                defaultMessage: 'Activity info',
                                            })}
                                            description={projectDetails?.information}
                                            attachments={projectDetails?.attachments}
                                            cover={projectDetails?.cover?.url}
                                        />
                                    </Accordion>
                                    {(!(projectDetails?.projectType === 'news' && !isApproval) ||
                                        projectDetails?.projectType === 'news') &&
                                        !hasNoAction && (
                                            <Accordion
                                                id={2}
                                                title={intl.formatMessage({
                                                    id: 'modals.news_execution.action.title',
                                                    defaultMessage: 'Action',
                                                })}
                                                activeIndex={activeIndexAction}
                                                setActiveIndex={setActiveIndexAction}
                                                className={`${componentClass}__accordion`}>
                                                {(projectDetails?.projectType === 'news' ||
                                                    projectDetails?.requiredConfirmReading ||
                                                    isApproval ||
                                                    (projectDetails &&
                                                        projectDetails.status === 'draft') ||
                                                    (projectDetails &&
                                                        projectDetails.status ===
                                                            'toBeReleased')) && (
                                                    <ActionApproval
                                                        showStoresDetail={() => {
                                                            setActiveDetail(4)
                                                        }}
                                                        onClose={onClose}
                                                        showReassignApproval={reassignApproverEnabled()}
                                                    />
                                                )}
                                                {projectDetails?.projectType !== 'news' &&
                                                    !projectDetails?.requiredConfirmReading &&
                                                    !isApproval &&
                                                    projectDetails?.status !== 'draft' &&
                                                    projectDetails?.status !== 'toBeReleased' && (
                                                        <Action
                                                            actions={actions}
                                                            storeId={storeId}
                                                            isMultiStore={isMultiStore}
                                                            loading={props.loadingProjectDetails}
                                                            storeList={projectDetails?.storesList}
                                                            onSelectedStore={(storeId) =>
                                                                onSelectedStore(storeId)
                                                            }
                                                            taskEmptyAnswer={taskEmptyAnswer}
                                                            onTaskEmptyAnswer={setTaskEmptyAnswer}
                                                            onTaskEmptyAnswerSave={() =>
                                                                taskEmptyAnswerDispatch(
                                                                    projectDetails?._id,
                                                                    storeId,
                                                                    taskEmptyAnswer,
                                                                    storeIdList,
                                                                    intl.formatMessage({
                                                                        id: 'modals.activity.execution.question.answer.success.message',
                                                                        defaultMessage:
                                                                            'Question answered successfully!',
                                                                    })
                                                                )
                                                            }
                                                            taskEmptyAnswerAttachments={
                                                                taskEmptyAnswerAttachments
                                                            }
                                                            onTaskEmptyAnswerAttachments={
                                                                setTaskEmptyAnswerAttachments
                                                            }
                                                            assignment={emptyAnswerAssignment}
                                                            emptyAnswerStatus={emptyAnswerStatus}
                                                            hasNoAction={hasNoAction}
                                                            taskCreationDate={taskCreationDate}
                                                            isPhotographicTask={[
                                                                SmartlyActionSubtypes.PICTURE_MGMT,
                                                                // SmartlyActionSubtypes.SERVICE_REQUEST,
                                                            ].includes(
                                                                projectDetails?.type as SmartlyActionSubtypes
                                                            )}
                                                            numberOfPhotos={
                                                                projectDetails?.numberOfPhotos || 0
                                                            }
                                                            projectTitle={
                                                                projectDetails?.projectTitle
                                                            }
                                                            projectTypeLabel={
                                                                projectDetails?.type &&
                                                                projectDetails?.childrenSubType
                                                                    ? intl.formatMessage({
                                                                          id:
                                                                              'ph2.modals.activity_list.task.' +
                                                                              projectDetails?.type,
                                                                          defaultMessage:
                                                                              projectDetails?.type,
                                                                      }) +
                                                                      ' - ' +
                                                                      intl.formatMessage({
                                                                          id: `ph2.photographic_task.type.${projectDetails?.childrenSubType}`,
                                                                          defaultMessage:
                                                                              projectDetails?.childrenSubType,
                                                                      })
                                                                    : ''
                                                            }
                                                            projectType={projectDetails?.type}
                                                            projectId={projectDetails?._id}
                                                            canUpload={getCanUpload()}
                                                            showAcceptDisclaimer={
                                                                showAcceptDisclaimer
                                                            }
                                                            showReassignApprover={reassignApproverEnabled()}
                                                            onReassignApprover={onReassignApprover}
                                                        />
                                                    )}
                                            </Accordion>
                                        )}
                                    {!!projectDetails && projectDetails.enableMessaging && (
                                        <Accordion
                                            id={3}
                                            title={intl.formatMessage({
                                                id: 'modals.news_execution.messaging.title',
                                                defaultMessage: 'Messaging',
                                            })}
                                            activeIndex={activeIndexMessaging}
                                            setActiveIndex={setActiveIndexMessaging}
                                            customIcon={
                                                messageList.filter((message) => message.isUnread)
                                                    .length > 0 && (
                                                    <div
                                                        className={`${componentClass}__messaging-icon`}></div>
                                                )
                                            }
                                            className={`${componentClass}__accordion`}>
                                            <Messaging />
                                        </Accordion>
                                    )}
                                </>
                            ) : (
                                getDetailSection()
                            )}
                        </MainContent>
                        {footer}
                    </div>
                </div>
                <DialogDuplicate
                    dialogVisible={showDuplicateDialog}
                    onSave={(confirm) =>
                        confirm
                            ? goToEdit({
                                  id: projectDetails._id,
                                  storeIdList: projectDetails.storesIdList[0],
                                  isClone: true,
                              })
                            : setShowDuplicateDialog(false)
                    }
                    onHide={() => setShowDuplicateDialog(false)}
                />
                <DialogRedo
                    dialogVisible={openDialogRedo}
                    onConfirm={(question, task, survey) => onRedoAllConfirm(question, task, survey)}
                    onHide={() => setOpenDialogRedo(false)}
                    hideQuestion={
                        !!projectDetails?.storesList &&
                        (!projectDetails?.storesList[0]?.questionsStores?.length ||
                            !projectDetails?.storesList[0]?.questionsStores[0]?.questionStore
                                ?.length)
                    }
                    hideSurvey={
                        !!projectDetails?.storesList &&
                        (!projectDetails?.storesList[0]?.surveysStores?.length ||
                            !projectDetails?.storesList[0]?.surveysStores[0]?.surveysStore?.length)
                    }
                    hideTask={
                        !!projectDetails?.storesList &&
                        (!projectDetails?.storesList[0]?.jobsStores?.length ||
                            !projectDetails?.storesList[0]?.jobsStores[0]?.jobStore?.length)
                    }
                />
                <DialogReject
                    dialogVisible={showRejectDialog}
                    onChange={setRejectReasons}
                    onSave={onRejectConfirm}
                    onHide={() => setShowRejectDialog(false)}
                />
                <DialogEditConfirm
                    dialogVisible={showEditDialogConfirm}
                    onSave={(confirm) => onDialogConfirm(confirm)}
                    onHide={() => setShowEditDialogConfirm(false)}
                    projectName={projectDetails?.projectTitle}
                />
                {showReassignDialog && (
                    <ReassignDialog
                        visible={showReassignDialog}
                        projectDetails={projectDetails}
                        storesList={projectDetails?.storesList}
                        delegateWhat={delegateType}
                        storeId={storeId}
                        hideReassignmentSize={
                            projectDetails?.type === SmartlyActionSubtypes.PICTURE_MGMT
                        }
                        onHide={() => setShowReassignDialog(false)}
                    />
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    messageList: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].messageList,
    isApproval: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isApproval,
    isMultiStore: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isMultiStore,
    isFullScreen: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isFullScreen,
    storeId: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].storeId,
    selectedStores: state[NEW_ACTIVITY_APPROVAL_REDUCER_NAMESPACE].selectedStores,
    approvalStoreList: state[NEW_ACTIVITY_APPROVAL_REDUCER_NAMESPACE].approvalStoreList,
    projectId: state.layoutReducer.modals.props?.id,
    storeIdList: state.layoutReducer.modals.props?.storeIds,
    executionProjectId: state.layoutReducer.modals.props?.executionProjectId,
    isFromVisit: state.layoutReducer.modals.props?.isFromVisit,
    projectDetails: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].projectDetails,
    loadingProjectDetails: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].loadingProjectDetails,
    assignees: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].assignees,
    loadingAssignees: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].loadingAssignees,
    user: state.userReducer.user,
    jwt: state.userReducer.accessToken,
    loadingSurveyStatus: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].loadingSurveyStatus,
    surveyStatusUpdateMap: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].surveyStatusUpdateMap,
    mode: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].mode,
    activityPhotoList: state[NEW_ACTIVITY_EXECUTION_NAMESPACE].activityPhotoList,
    isPhotographicApprovalAccept:
        state[NEW_ACTIVITY_EXECUTION_NAMESPACE].isPhotographicApprovalAccept,
    layoutBreadcrumbs: state.layoutReducer.breadcrumbs,
})

const mapDispatchToProps = (dispatch: any) => ({
    onCloseSurveyTask: (modal) => {
        dispatch(setMessageList([]))
        dispatch(setStoreId(null))
        dispatch(resetAllForm())
        dispatch(setSelectedStores([]))
        dispatch(layoutActions.setModals(modal))
    },
    onClose: () => {
        dispatch(setMessageList([]))
        dispatch(setStoreId(null))
        dispatch(resetAllForm())
        dispatch(setSelectedStores([]))
        dispatch(
            layoutActions.setModals({
                type: null,
                props: {
                    id: null,
                    storeIdList: null,
                    isEdit: false,
                    isClone: false,
                    isFromVisit: false,
                },
            })
        )
    },
    goToEdit: ({
        type,
        ...props
    }: {
        id: string
        storeIdList: string[]
        isClone: boolean
        isEdit?: boolean
        type?: LayoutActivityType
    }) => {
        dispatch(setStoreId(null))
        dispatch(
            layoutActions.setModals({
                type:
                    type === LayoutActivityType.SURVEY_TASK
                        ? ModalsType.NEW_SURVEY_TASK
                        : ModalsType.NEW_ACTIVITY,
                props,
            })
        )
    },
    setIsApproval: (value) => {
        dispatch(setIsApproval(value))
    },
    setIsMultiStore: (value) => {
        dispatch(setIsMultiStore(value))
    },
    setIsFullScreen: (value) => {
        dispatch(setIsFullScreen(value))
    },
    setStoreId: (storeId) => {
        dispatch(setStoreId(storeId))
    },
    setSelectedStore: (storeList) => {
        dispatch(setSelectedStores(storeList))
    },
    getProjectDetails: (projectId: string, stores?: string[]) => {
        dispatch(getProjectDetails(projectId, stores))
    },
    reloadProjectStatus: (projectId: string, stores?: string[], callback?: (data) => void) => {
        dispatch(reloadProjectStatus(projectId, stores, callback))
    },
    approveStore: (params: {
        projectId: string
        storeId: string
        successMessage: string
        reloadPhotoList: boolean
    }) => {
        dispatch(approveStore(params))
    },
    closeProjectAction: (
        projectId: string,
        storeIds: string[],
        successMessage: string,
        storeIdList
    ) => {
        dispatch(closeProjectAction(projectId, storeIds, successMessage, storeIdList))
    },
    getAssignees: (storeId: string, profileList?: string[]) => {
        dispatch(getAssignees(storeId, profileList))
    },
    answerQuestion: (
        projectId: string,
        questionId: string,
        answer: string,
        jobId?: string,
        successMessage?: string,
        answerAttachments?: any[]
    ) => {
        dispatch(
            answerQuestion(projectId, questionId, answer, jobId, successMessage, answerAttachments)
        )
    },

    redoStore: (
        projectId: string,
        storeIds: string[],
        questionsReasons: string,
        tasksReasons: string,
        surveysReasons: string,
        successMessage: string,
        successCallback: () => void,
        storeIdList
    ) => {
        dispatch(
            redoStore(
                projectId,
                storeIds,
                questionsReasons,
                tasksReasons,
                surveysReasons,
                successMessage,
                successCallback,
                storeIdList
            )
        )
    },
    cancelProject: (projectId: string, successMessage: string) =>
        dispatch(cancelProject(projectId, successMessage)),
    recallProject: (projectId: string, successMessage: string) =>
        dispatch(recallProject(projectId, successMessage)),
    releaseProject: (projectId: string, successMessage: string) =>
        dispatch(releaseProject(projectId, successMessage)),
    rejectProject: (projectId: string, message: string, successMessage: string) =>
        dispatch(rejectProject(projectId, message, successMessage)),
    createProject: (form: ProjectApiCreateActivityBody, successMessage: string) =>
        dispatch(createProject(form, successMessage)),
    markAsRead: (projectId: string, isRead: boolean, successMessage: string, storeIdList) =>
        dispatch(markAsRead(projectId, isRead, successMessage, storeIdList)),
    saveAsToBeReleased: (projectId: string, successMessage: string, storeIdList) =>
        dispatch(saveAsToBeReleased(projectId, successMessage, storeIdList)),
    taskEmptyAnswerDispatch: (
        projectId: string,
        storeId: string,
        answer: string,
        storeIdList,
        successMessage: string
    ) => dispatch(taskEmptyAnswer(projectId, storeId, answer, storeIdList, successMessage)),
    setApprovalStoreList: (value) => dispatch(setApprovalStoreList(value)),
    getSurveyStatus: (surveyId: string, storeId: string, projectId: string) =>
        dispatch(getSurveyStatus(surveyId, storeId, projectId)),
    editProject: (newProject, successMessage: string, statusAction: string) =>
        dispatch(editProject(newProject, null, null, null, successMessage, statusAction)),
    getFiltersDomain: () => {
        dispatch(getFiltersDomain())
    },
    acceptPhotographicTask: (params: {
        projectId: string
        storeId: string
        successMessage: string
    }) => {
        dispatch(acceptPhotographicTask(params))
    },
    acceptApprovalPhotographicTask: (params: {
        projectId: string
        storeIdList: string[]
        successMessage: string
        callback: () => void
    }) => {
        dispatch(acceptApprovalPhotographicTask(params))
    },
    acceptApprovalServiceRequestApprovalDetail: (params: {
        projectId: string
        storeIdList: string[]
        successMessage: string
    }) => {
        dispatch(acceptApprovalServiceRequestApprovalDetail(params))
    },
    setActivityKey: (key: LayoutActivityType) => dispatch(setActivityKey(key)),
    setBreadcrumbNavigation: (breadcrumbNavigation: any) =>
        dispatch(layoutActions.setBreadcrumbNavigation(breadcrumbNavigation)),
    resetBreadcrumbs: () => dispatch(layoutActions.resetBreadcrumb()),
    getMessage: (params: GetMessageParams) => dispatch(getMessage(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TaskCommunicationExecution)
